<template>
    <footer class="footer wrap">
        <div class="footer_top container">
            <div class="footer_nav">
                <dl
                    v-for="footerMenu in menu"
                    :key="footerMenu.name"
                    v-show="footerMenu.name!=='provision'"
                >
                    <dt>{{footerMenu.meta.text}}</dt>
                    <dd v-for="item in footerMenu.children" :key="item.name">
                        <router-link :to="{name: item.name}">{{item.meta.text}}</router-link>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="containers">
            <div class="complaint">
                <div class="icon-title">投诉方式</div>
                <div class="icon-content">
                    <div class="icon-img"></div>
                    <a href="tel:400-000-0056" v-if="isMobile">400-000-0056</a>
                    <span v-else>400-000-0056</span>
                </div>
                <div class="icon-content" @click="clickTr($event,1)">
                    <div class="icon-img">
                        <div class="icon-qt">
                            <img src="../../images/footer-side/code_wechat.jpg">
                        </div>
                    </div>
                    <span>
                        <span v-show="!isMobile">微信</span>公众号
                    </span>
                </div>
                <div class="icon-content" v-if="!applet">
                    <a href="https://m.weibo.cn/u/2695412380" target="_blank" v-if="isMobile">
                        <div class="icon-img"></div>
                        <span>微博</span>
                    </a>
                    <a href="https://weibo.com/anntoworld" target="_blank" v-else>
                        <div class="icon-img"></div>
                        <span><span>官方</span>微博</span>
                    </a>
                </div>
                <div class="icon-title">资讯&服务</div>
                <div class="icon-content" @click="clickTr($event,3)">
                    <div class="icon-img">
                        <div class="icon-qt">
                            <img src="../../images/footer-side/code_dyh.png">
                        </div>
                    </div>
                    <span>
                        <span v-show="!isMobile">微信</span>订阅号
                    </span>
                </div>
                <div class="icon-content" @click="clickTr($event,4)">
                    <!-- <div href="https://an.midea.com/desktop/ztb-cp/download.html" v-if="isMobile"> -->
                    <div v-if="isMobile">
                        <div class="icon-img">
                            <div class="icon-qt">
                                <img src="../../images/footer-side/code_ztb.jpg">
                            </div>
                        </div>
                        <span>直通宝<span v-show="!isMobile">APP</span></span>
                    </div>
                    <div v-else>
                        <div class="icon-img">
                            <div class="icon-qt">
                                <img src="../../images/footer-side/code_ztb.jpg">
                            </div>
                        </div>
                        <span>直通宝<span v-show="!isMobile">APP</span></span>
                    </div>
                </div>
                <!-- <div class="icon-content" @click="clickTr($event,2)">
                    <div class="icon-img">
                        <div class="icon-qt">
                            <img src="../../images/footer-side/code_weui.png">
                        </div>
                    </div>
                    <span>
                        <span v-show="!isMobile">直通宝</span>
                        小程序
                    </span>
                </div> -->
            </div>
        </div>
        <div class="container">
            <p class="copyright">
                <span>Copyright &copy; 2023 安得智联供应链科技股份有限公司 版权所有</span>
                <span class="caseNo"><a href="http://beian.miit.gov.cn" target="_blank"> 皖ICP备2021008228号-3</a></span>
                <router-link :to="{name:'terms'}" class="provision">
                    <span @click="toTop">服务条款</span>
                </router-link>
                <router-link :to="{name:'privacy'}" class="provision">
                    <span @click="toTop">隐私政策</span>
                </router-link>
            </p>
        </div>
        <div class="QT_bg" v-show="QRcode">
            <a class="t_close" @click="closeDetail"></a>
            <div class="QT_bg_desc">
                <h5 v-html="imageName"></h5>
                <img :src="image">
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'main-footer',
    data() {
        return {
            menu: [],
            isMobile: this.COMMON.isMobile,
            QRcode: false,
            image: '',
            imageName: '',
            applet: '',
        };
    },
    created() {
        this.applet = sessionStorage.getItem('my_applet') || '';
    },
    methods: {
        toTop() {
            window.scroll(0, 0);
        },
        clickTr(e, name) {
            if (this.isMobile || this.applet) {
                e.preventDefault();
                this.showDetail(name);
            }
        },
        showDetail(name) {
            document.body.style.overflow = 'hidden';
            if (name === 1) {
                this.imageName = '微信公众号';
                this.image = require('../../images/footer-side/yd/wechat_code.jpg');
            }else if (name === 2){
                this.imageName = '直通宝小程序';
                this.image = require('../../images/footer-side/yd/weui_code.png');
            }else if (name === 4){
                this.imageName = '直通宝APP';
                this.image = require('../../images/footer-side/code_ztb.jpg');
            }else{
                this.imageName = '微信订阅号';
                this.image = require('../../images/footer-side/yd/dyh_code.png');
            }
            this.QRcode = true;
        },
        closeDetail() {
            document.body.style.overflow = 'auto';
            this.QRcode = false;
        }
    },
    mounted() {
        this.menu = this.$router.options.routes.filter(
            item => item.name !== 'main-index' && item.meta
        );
    }
};
</script>
<style lang="less">
@import url(./style/footer.less);
</style>
